import { render, staticRenderFns } from "./NormalSearchNav283.vue?vue&type=template&id=00be96c0&scoped=true"
import script from "./NormalSearchNav283.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav283.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be96c0",
  null
  
)

export default component.exports